import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../css/Awards.css';

const Awards = () => {
  const [awards, setAwards] = useState([]);
  const [displayawards, setDisplayawards] = useState([]);

  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    description: '',
    awardimgurl: '',

  });

  const [editingAward, setEditingAward] = useState(null); // for modal open
    const [editedDescription, setEditedDescription] = useState('');
    const [editedAwardurl, setEditedAwardurl] = useState('');


  useEffect(() => {
    const fetchawards = async () => {
      try {
        const res = await axios.get('/api/awardslist');
        setDisplayawards(res.data);
      } catch (error) {
        console.error('Error fetching awards:', error);
      }
    };
    fetchawards();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const imagedata = new FormData();
    imagedata.append('file', file);
    imagedata.append('upload_preset', 'unsigned_upload');

    const res = await fetch('https://api.cloudinary.com/v1_1/dccuq6ut4/upload', {
      method: 'POST',
      body: imagedata,
    });

    const data = await res.json();
    setFormData((prev) => ({
      ...prev,
      awardimgurl: data.secure_url,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.description || !formData.awardimgurl) {
      alert('Please fill in all fields and upload an image');
      return;
    }

    try {
      if (editingId) {
        // ===== Update existing award =====
        const res = await axios.put(
          `/api/awards/${editingId}`,
          {
            description: formData.description,
            awardimgurl: formData.awardimgurl,
          }
        );
        alert('Award updated successfully!');
      } else {
        // ===== Add new award =====
        const res = await axios.post('/api/awards', formData);
        alert('Award added successfully!');
      }

      // Refresh awards
      const updatedRes = await axios.get('/api/awardslist');
      setDisplayawards(updatedRes.data);

      // Reset form
      setFormData({ description: '', awardimgurl: '', imageFile: null });
      setEditingId(null);
      setShowForm(false);
    } catch (error) {
      console.error('Error submitting award:', error);
      alert('Something went wrong.');
    }
  };

  // const handleEdit = (award) => {
  //   setFormData({
  //     description: award.description,
  //     awardimgurl: award.awardimgurl,
  //     imageFile: null,
  //   });
  //   setEditingId(award._id);
  //   setShowForm(true);
  // };
    const handleEdit = (id) => {
    const awardToEdit = displayawards.find((awd) => awd._id === id);
    setEditingAward(awardToEdit);
    //setEditedDescription(awardToEdit.description);
    //setEditedAwardurl(awardToEdit.awardimgurl);
    setEditingId(awardToEdit._id);
     setFormData({
    description: awardToEdit.description,
    awardimgurl: awardToEdit.awardimgurl,
   
  });
    setShowForm(true);
  };
  
  const handleSaveEdit = async () => {
    if (!editingAward) return;
  
    try {
      const response = await fetch(`/api/awards/${editingId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          //title: editedTitle,
          description: formData.description,
        }),
      });
      console.log('response', response);
      console.log('inside try block');
      const data = await response.json();
      if (response.ok) {
        // Update frontend instantly
        setDisplayawards((prevAwards) =>
          prevAwards.map((awd) =>
            awd._id === editingId ? { ...awd, description: formData.description } : awd
          )
        );
        setEditingId(null);
        alert(data.message);
        setFormData({ description: "", awardimgurl: "", imageFile: null });
        setShowForm(false);
      } else {
        alert(data.message || 'Failed to update award');
      }
    } catch (error) {
      console.error('Error updating award:', error);
      alert('Error updating award');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this award?')) {
      try {
        await axios.delete(`/api/deleteawards/${id}`);
        setDisplayawards((prev) => prev.filter((a) => a._id !== id));
        alert('Award deleted successfully!');
      } catch (error) {
        console.error('Error deleting award:', error);
        alert('failed to delte');
      }
    }
  };

  const handleCancel = () => {
    setFormData({ description: '', awardimgurl: '', imageFile: null });
    setEditingId(null);
    setShowForm(false);
  };

  const handleAddNew = () => {
    setFormData({ description: '', awardimgurl: '', imageFile: null });
    setEditingId(null);
    setShowForm(true);
  };

  // =================== STYLES ===================
  // const styles = {
  //   container: {
  //     minHeight: '100vh',
  //     backgroundColor: '#f5f5f5',
  //     padding: '40px 20px',
  //     maxWidth: '1400px',
  //     margin: '0 auto',
  //   },
  //   header: {
  //     display: 'flex',
  //     justifyContent: 'space-between',
  //     alignItems: 'center',
  //     marginBottom: '40px',
  //     flexWrap: 'wrap',
  //     gap: '20px',
  //   },
  //   title: {
  //     fontSize: '2rem',
  //     fontWeight: '700',
  //     color: '#333',
  //     margin: 0,
  //   },
  //   btnAdd: {
  //     backgroundColor: '#333',
  //     color: 'white',
  //     border: 'none',
  //     padding: '12px 24px',
  //     borderRadius: '6px',
  //     fontSize: '1rem',
  //     fontWeight: '600',
  //     cursor: 'pointer',
  //     transition: 'all 0.3s ease',
  //   },
  //   overlay: {
  //     position: 'fixed',
  //     top: 0,
  //     left: 0,
  //     right: 0,
  //     bottom: 0,
  //     backgroundColor: 'rgba(0, 0, 0, 0.6)',
  //     display: 'flex',
  //     justifyContent: 'center',
  //     alignItems: 'center',
  //     zIndex: 1000,
  //     padding: '20px',
  //   },
  //   formContainer: {
  //     backgroundColor: 'white',
  //     borderRadius: '12px',
  //     padding: '40px',
  //     maxWidth: '600px',
  //     width: '100%',
  //     maxHeight: '90vh',
  //     overflowY: 'auto',
  //     boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
  //   },
  //   formTitle: {
  //     fontSize: '1.75rem',
  //     fontWeight: '700',
  //     color: '#333',
  //     margin: '0 0 30px 0',
  //     textAlign: 'center',
  //   },
  //   formContent: {
  //     display: 'flex',
  //     flexDirection: 'column',
  //     gap: '24px',
  //   },
  //   label: {
  //     fontSize: '0.95rem',
  //     fontWeight: '600',
  //     color: '#555',
  //   },
  //   textarea: {
  //     padding: '12px',
  //     border: '2px solid #ccc',
  //     borderRadius: '6px',
  //     fontSize: '1rem',
  //     resize: 'vertical',
  //     minHeight: '100px',
  //   },
  //   fileInputLabel: {
  //     display: 'flex',
  //     alignItems: 'center',
  //     justifyContent: 'center',
  //     padding: '12px',
  //     border: '2px dashed #ccc',
  //     borderRadius: '6px',
  //     backgroundColor: '#fafafa',
  //     cursor: 'pointer',
  //   },
  //   previewImage: {
  //     width: '100%',
  //     maxHeight: '300px',
  //     objectFit: 'cover',
  //     borderRadius: '8px',
  //     border: '2px solid #e0e0e0',
  //   },
  //   formActions: {
  //     display: 'flex',
  //     gap: '12px',
  //     marginTop: '10px',
  //   },
  //   btnSubmit: {
  //     flex: 1,
  //     padding: '14px',
  //     borderRadius: '6px',
  //     backgroundColor: '#333',
  //     color: 'white',
  //     border: 'none',
  //     fontWeight: '600',
  //     cursor: 'pointer',
  //   },
  //   btnCancel: {
  //     flex: 1,
  //     padding: '14px',
  //     border: '2px solid #ccc',
  //     borderRadius: '6px',
  //     backgroundColor: 'white',
  //     fontWeight: '600',
  //     cursor: 'pointer',
  //   },
  //   grid: {
  //     display: 'grid',
  //     gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
  //     gap: '30px',
  //   },
  //   actions: {
  //     display: 'flex',
  //     gap: '10px'
  //   },
  //   btnEdit: {
  //     flex: 1,
  //     padding: '10px',
  //     border: 'none',
  //     borderRadius: '6px',
  //     fontSize: '0.9rem',
  //     fontWeight: '600',
  //     cursor: 'pointer',
  //     transition: 'all 0.3s ease',
  //     backgroundColor: '#555',
  //     color: 'white'
  //   },
  //   btnDelete: {
  //     flex: 1,
  //     padding: '10px',
  //     border: '2px solid #d32f2f',
  //     borderRadius: '6px',
  //     fontSize: '0.9rem',
  //     fontWeight: '600',
  //     cursor: 'pointer',
  //     transition: 'all 0.3s ease',
  //     backgroundColor: 'white',
  //     color: '#d32f2f'
  //   },
  // };

  return (
    <div className='container'>
      {/* Header */}
      <div className='awardheader'>
        <h1 className='awardtitle'>Awards Management</h1>
        <button className='btn-add' onClick={handleAddNew}>
          + Add New Award
        </button>
      </div>

      {/* Modal Form */}
      {showForm && (
        <div className='overlay'>
          <div className='form-container'>
            <h2 className='form-title'>
              {editingId ? 'Edit Award' : 'Add New Award'}
            </h2>

            <div className='form-content'>
              {/* Description */}
              <div>
                <label className='label'>Description</label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  //style={styles.textarea}
                  className='textarea'
                  placeholder="Enter award description..."
                />
              </div>

              {/* Image Section */}
              {editingId ? (
                <div>
                  <p className='label'>Existing Image:</p>
                  <img
                    src={formData.awardimgurl}
                    alt="Award"
                    //style={styles.previewImage}
                    className='preview-image'
                    onError={(e) =>
                      (e.target.src =
                        'https://via.placeholder.com/400x300?text=Invalid+Image')
                    }
                  />
                  <p
                    style={{
                      color: '#666',
                      fontSize: 13,
                      marginTop: 6,
                      fontStyle: 'italic',
                    }}
                  >
                    *Image cannot be changed in edit mode
                  </p>
                </div>
              ) : (
                <div>
                  <label className='label'>Upload Image</label>
                  <label className='file-input-label'>
                    <span>
                      {formData.imageFile
                        ? formData.imageFile.name
                        : 'Choose an image file'}
                    </span>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageUpload}
                      style={{ display: 'none' }}
                    />
                  </label>
                  {formData.awardimgurl && (
                    <img
                      src={formData.awardimgurl}
                      alt="Preview"
                      //style={styles.previewImage}
                      className='preview-image'
                    />
                  )}
                </div>
              )}

              {/* Buttons */}
              <div className='form-actions'>
                <button className='btn-submit' onClick={editingId ? handleSaveEdit : handleSubmit}>
                  {editingId ? 'Update Award' : 'Save Award'}
                </button>
                <button className='btn-cancel' onClick={handleCancel}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Display Cards */}
      <div className='grid'>
        {displayawards.map((award) => (
          <div key={award._id} style={{ backgroundColor: 'white', padding: 20, borderRadius: 8 }}>
            <img
              src={award.awardimgurl}
              alt={award.description}
              style={{ width: '100%', height: 200, objectFit: 'cover', borderRadius: 8 }}
            />
            <p style={{ marginTop: 10 }}>{award.description}</p>
             <div className='actions'>
                 <button 
                  //style={styles.btnEdit}
                  className='btn-edit'
                  onClick={() => handleEdit(award._id)}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#333';
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#555';
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  Edit
                </button>
                <button 
                  //style={styles.btnDelete}
                  className='btn-delete'
                  onClick={() => handleDelete(award._id)}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#d32f2f';
                    e.target.style.color = 'white';
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'white';
                    e.target.style.color = '#d32f2f';
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  Delete
                </button>
              </div>
            {/* <button onClick={() => handleEdit(award)} style={styles.btnSubmit}>Edit</button>
            <button onClick={() => handleDelete(award._id)} style={styles.btnSubmit}>Delete</button> */}
          </div>
        ))}
      </div>
    </div>
  );
};
// const Awards = () => {

//   const [awards, setAwards] = useState([]);
//   const [displayawards, setDisplayawards] = useState([]);
   

//   const [showForm, setShowForm] = useState(false);
//   const [editingId, setEditingId] = useState(null);
//   const [formData, setFormData] = useState({
//     description: '',
//     awardimgurl: '',
    
//   });

//    useEffect(() => {
//       const fetchawards = async () => {
//         try {
//           const res = await axios.get('http://localhost:5000/awardslist');
//           setDisplayawards(res.data);
//           //setLoading(false);
//         } catch (error) {
//           console.error("Error fetching awards:", error);
//           //setLoading(false);
//         }
//       };
  
//       fetchawards();
//     }, []);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleImageUpload = async (e) => {
//   const file = e.target.files[0];  // Only the selected image
//   const imagedata = new FormData();
//   imagedata.append('file', file);   // Upload just the file
//   imagedata.append('upload_preset', 'unsigned_upload'); // Preset needed by Cloudinary

//   const res = await fetch('https://api.cloudinary.com/v1_1/dccuq6ut4/upload', {
//     method: 'POST',
//     body: imagedata,
//   });

//   const data = await res.json();
//   console.log('Uploaded Image URL:', data.secure_url); 
//   setFormData(prev => ({
//         ...prev,
//         awardimgurl: data.secure_url
//       }));
    
//     const reader = new FileReader();
//       reader.onload = (e) => {
//         const preview = e.target.result;
        
//         console.log('imagepreview', preview);
//       };
//       reader.readAsDataURL(file);
// };
 

//   const handleSubmit = async (e) => {
//       e.preventDefault();
//     if (!formData.description || !formData.awardimgurl) {
//       alert('Please fill in all fields and upload an image');
//       return;
//     }

     
  
//     console.log('entered submit');
    
//     try {
//         const res = await axios.post('http://localhost:5000/awards', formData);
//          setAwards(res.data);
//         alert('Award added successfully!');
//       } catch (error) {
//         console.error("Error fetching members:", error);
        
//     }
//    setFormData({ description: '', awardimgurl: '' });
//     setShowForm(false);
    
//   };
    
   
  

//   const handleEdit = (award) => {
//     setFormData({
//       description: award.description,
//       imageUrl: award.imageUrl,
//       imageFile: null
//     });
//     setEditingId(award.id);
//     setShowForm(true);
//   };

//   const handleDelete = (id) => {
//     if (window.confirm('Are you sure you want to delete this award?')) {
//       setAwards(awards.filter(award => award.id !== id));
//     }
//   };

//   const handleCancel = () => {
//     setFormData({ description: '', imageUrl: '', imageFile: null });
//     setEditingId(null);
//     setShowForm(false);
//   };

//   const handleAddNew = () => {
//     setFormData({ description: '', imageUrl: '', imageFile: null });
//     setEditingId(null);
//     setShowForm(true);
//   };

//   const styles = {
//     container: {
//       minHeight: '100vh',
//       backgroundColor: '#f5f5f5',
//       padding: '40px 20px',
//       maxWidth: '1400px',
//       margin: '0 auto'
//     },
//     header: {
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       marginBottom: '40px',
//       flexWrap: 'wrap',
//       gap: '20px'
//     },
//     title: {
//       fontSize: '2rem',
//       fontWeight: '700',
//       color: '#333',
//       margin: 0
//     },
//     btnAdd: {
//       backgroundColor: '#333',
//       color: 'white',
//       border: 'none',
//       padding: '12px 24px',
//       borderRadius: '6px',
//       fontSize: '1rem',
//       fontWeight: '600',
//       cursor: 'pointer',
//       transition: 'all 0.3s ease'
//     },
//     overlay: {
//       position: 'fixed',
//       top: 0,
//       left: 0,
//       right: 0,
//       bottom: 0,
//       backgroundColor: 'rgba(0, 0, 0, 0.6)',
//       display: 'flex',
//       justifyContent: 'center',
//       alignItems: 'center',
//       zIndex: 1000,
//       padding: '20px'
//     },
//     formContainer: {
//       backgroundColor: 'white',
//       borderRadius: '12px',
//       padding: '40px',
//       maxWidth: '600px',
//       width: '100%',
//       maxHeight: '90vh',
//       overflowY: 'auto',
//       boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)'
//     },
//     formTitle: {
//       fontSize: '1.75rem',
//       fontWeight: '700',
//       color: '#333',
//       margin: '0 0 30px 0',
//       textAlign: 'center'
//     },
//     formContent: {
//       display: 'flex',
//       flexDirection: 'column',
//       gap: '24px'
//     },
//     formGroup: {
//       display: 'flex',
//       flexDirection: 'column',
//       gap: '8px'
//     },
//     label: {
//       fontSize: '0.95rem',
//       fontWeight: '600',
//       color: '#555'
//     },
//      labelHint: {
//       fontSize: '0.85rem',
//       fontWeight: '400',
//       color: '#888',
//       marginTop: '4px'
//     },
//     input: {
//       padding: '12px',
//       border: '2px solid #ccc',
//       borderRadius: '6px',
//       fontSize: '1rem',
//       fontFamily: 'inherit',
//       transition: 'border-color 0.3s ease',
//       backgroundColor: 'white'
//     },
//     textarea: {
//       padding: '12px',
//       border: '2px solid #ccc',
//       borderRadius: '6px',
//       fontSize: '1rem',
//       fontFamily: 'inherit',
//       transition: 'border-color 0.3s ease',
//       backgroundColor: 'white',
//       resize: 'vertical',
//       minHeight: '100px'
//     },
//     fileInputWrapper: {
//       position: 'relative',
//       overflow: 'hidden',
//       display: 'inline-block',
//       width: '100%'
//     },
//     fileInput: {
//       position: 'absolute',
//       fontSize: '100px',
//       opacity: 0,
//       right: 0,
//       top: 0,
//       cursor: 'pointer'
//     },
//     fileInputLabel: {
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       gap: '10px',
//       padding: '12px',
//       border: '2px dashed #ccc',
//       borderRadius: '6px',
//       backgroundColor: '#fafafa',
//       cursor: 'pointer',
//       transition: 'all 0.3s ease',
//       fontSize: '1rem',
//       color: '#555',
//       fontWeight: '500'
//     },
//     uploadIcon: {
//       fontSize: '1.5rem'
//     },
//     preview: {
//       marginTop: '10px'
//     },
//     previewLabel: {
//       fontSize: '0.9rem',
//       fontWeight: '600',
//       color: '#555',
//       marginBottom: '10px'
//     },
//     previewImage: {
//       width: '100%',
//       maxHeight: '300px',
//       objectFit: 'cover',
//       borderRadius: '8px',
//       border: '2px solid #e0e0e0'
//     },
//     formActions: {
//       display: 'flex',
//       gap: '12px',
//       marginTop: '10px'
//     },
//     btnSubmit: {
//       flex: 1,
//       padding: '14px',
//       border: 'none',
//       borderRadius: '6px',
//       fontSize: '1rem',
//       fontWeight: '600',
//       cursor: 'pointer',
//       transition: 'all 0.3s ease',
//       backgroundColor: '#333',
//       color: 'white'
//     },
//     btnCancel: {
//       flex: 1,
//       padding: '14px',
//       border: '2px solid #ccc',
//       borderRadius: '6px',
//       fontSize: '1rem',
//       fontWeight: '600',
//       cursor: 'pointer',
//       transition: 'all 0.3s ease',
//       backgroundColor: 'white',
//       color: '#333'
//     },
//     grid: {
//       display: 'grid',
//       gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
//       gap: '30px'
//     },
//     card: {
//       backgroundColor: 'white',
//       borderRadius: '12px',
//       overflow: 'hidden',
//       boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
//       transition: 'all 0.3s ease',
//       border: '2px solid #e0e0e0'
//     },
//     imageWrapper: {
//       width: '100%',
//       height: '220px',
//       overflow: 'hidden',
//       backgroundColor: '#f5f5f5'
//     },
//     image: {
//       width: '100%',
//       height: '100%',
//       objectFit: 'cover',
//       transition: 'transform 0.3s ease'
//     },
//     content: {
//       padding: '20px'
//     },
//     description: {
//       fontSize: '1rem',
//       color: '#333',
//       margin: '0 0 20px 0',
//       lineHeight: '1.5',
//       minHeight: '48px'
//     },
//     actions: {
//       display: 'flex',
//       gap: '10px'
//     },
//     btnEdit: {
//       flex: 1,
//       padding: '10px',
//       border: 'none',
//       borderRadius: '6px',
//       fontSize: '0.9rem',
//       fontWeight: '600',
//       cursor: 'pointer',
//       transition: 'all 0.3s ease',
//       backgroundColor: '#555',
//       color: 'white'
//     },
//     btnDelete: {
//       flex: 1,
//       padding: '10px',
//       border: '2px solid #d32f2f',
//       borderRadius: '6px',
//       fontSize: '0.9rem',
//       fontWeight: '600',
//       cursor: 'pointer',
//       transition: 'all 0.3s ease',
//       backgroundColor: 'white',
//       color: '#d32f2f'
//     },
//     emptyState: {
//       textAlign: 'center',
//       padding: '60px 20px',
//       backgroundColor: 'white',
//       borderRadius: '12px',
//       border: '2px dashed #ccc'
//     },
//     emptyText: {
//       fontSize: '1.1rem',
//       color: '#777',
//       margin: 0
//     }
//   };

//   return (
//     <div style={styles.container}>
//       <div style={styles.header}>
//         <h1 style={styles.title}>Awards Management</h1>
//         <button 
//           style={styles.btnAdd}
//           onClick={handleAddNew}
//           onMouseEnter={(e) => {
//             e.target.style.backgroundColor = '#000';
//             e.target.style.transform = 'translateY(-2px)';
//             e.target.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';
//           }}
//           onMouseLeave={(e) => {
//             e.target.style.backgroundColor = '#333';
//             e.target.style.transform = 'translateY(0)';
//             e.target.style.boxShadow = 'none';
//           }}
//         >
//           + Add New Award
//         </button>
//       </div>

//       {showForm && (
//         <div style={styles.overlay}>
//           <div style={styles.formContainer}>
//             <h2 style={styles.formTitle}>
//               {editingId ? 'Edit Award' : 'Add New Award'}
//             </h2>
            
//             <div style={styles.formContent}>
//               <div style={styles.formGroup}>
//                 <label style={styles.label}>Description</label>
//                 <textarea
//                   name="description"
//                   value={formData.description}
//                   onChange={handleInputChange}
//                   style={styles.textarea}
//                   placeholder="Enter award description..."
//                   onFocus={(e) => e.target.style.borderColor = '#333'}
//                   onBlur={(e) => e.target.style.borderColor = '#ccc'}
//                 />
//               </div>

//               <div style={styles.formGroup}>
//                 <label style={styles.label}>Upload Image</label>
//                 <p style={styles.labelHint}>PNG, JPG, GIF up to 5MB</p>
//                 <div style={styles.fileInputWrapper}>
//                   <label 
//                     style={styles.fileInputLabel}
//                     onMouseEnter={(e) => {
//                       e.target.style.borderColor = '#333';
//                       e.target.style.backgroundColor = '#f0f0f0';
//                     }}
//                     onMouseLeave={(e) => {
//                       e.target.style.borderColor = '#ccc';
//                       e.target.style.backgroundColor = '#fafafa';
//                     }}
//                   >
                  
//                     <span>{formData.imageFile ? formData.imageFile.name : 'Choose an image file'}</span>
//                     <input
//                       type="file"
//                       accept="image/*"
//                       onChange={handleImageUpload}
//                       style={styles.fileInput}
//                     />
//                   </label>
//                 </div>
//               </div>

//               {formData.awardimgurl && (
//                 <div style={styles.preview}>
//                   <p style={styles.previewLabel}>Preview:</p>
//                   <img 
//                     src={formData.awardimgurl} 
//                     alt="Preview" 
//                     style={styles.previewImage}
//                     onError={(e) => e.target.src = 'https://via.placeholder.com/400x300?text=Invalid+Image'}
//                   />
//                 </div>
//               )}

//               <div style={styles.formActions}>
//                 <button 
//                   style={styles.btnSubmit}
//                   onClick={handleSubmit}
//                   onMouseEnter={(e) => {
//                     e.target.style.backgroundColor = '#000';
//                     e.target.style.transform = 'translateY(-2px)';
//                     e.target.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';
//                   }}
//                   onMouseLeave={(e) => {
//                     e.target.style.backgroundColor = '#333';
//                     e.target.style.transform = 'translateY(0)';
//                     e.target.style.boxShadow = 'none';
//                   }}
//                 >
//                   {editingId ? 'Update Award' : 'Save Award'}
//                 </button>
//                 <button 
//                   style={styles.btnCancel}
//                   onClick={handleCancel}
//                   onMouseEnter={(e) => {
//                     e.target.style.backgroundColor = '#f5f5f5';
//                     e.target.style.borderColor = '#999';
//                   }}
//                   onMouseLeave={(e) => {
//                     e.target.style.backgroundColor = 'white';
//                     e.target.style.borderColor = '#ccc';
//                   }}
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
    

//       <div style={styles.grid}>
//         {displayawards.map((award) => (
//           <div 
//             key={award._id} 
//             style={styles.card}
//             onMouseEnter={(e) => {
//               e.currentTarget.style.transform = 'translateY(-8px)';
//               e.currentTarget.style.boxShadow = '0 8px 16px rgba(0, 0, 0, 0.15)';
//               e.currentTarget.style.borderColor = '#333';
//               const img = e.currentTarget.querySelector('img');
//               if (img) img.style.transform = 'scale(1.05)';
//             }}
//             onMouseLeave={(e) => {
//               e.currentTarget.style.transform = 'translateY(0)';
//               e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
//               e.currentTarget.style.borderColor = '#e0e0e0';
//               const img = e.currentTarget.querySelector('img');
//               if (img) img.style.transform = 'scale(1)';
//             }}
//           >
//             <div style={styles.imageWrapper}>
//               <img
//                 src={award.awardimgurl}
//                 alt={award.description}
//                 style={styles.image}
//                 onError={(e) => e.target.src = 'https://via.placeholder.com/400x300?text=No+Image'}
//               />
//             </div>
            
//             <div style={styles.content}>
//               <p style={styles.description}>
               
//                 {award.description.split(/(\*\*.*?\*\*)/).map((part, index) =>
//     part.startsWith('**') && part.endsWith('**') ? (
//       <strong key={index}>{part.slice(2, -2)}</strong>
//     ) : (
//       <span key={index}>{part}</span>
//     )
//   )}
//                 </p>
                 

              
//               <div style={styles.actions}>
//                 <button 
//                   style={styles.btnEdit}
//                   onClick={() => handleEdit(award._id)}
//                   onMouseEnter={(e) => {
//                     e.target.style.backgroundColor = '#333';
//                     e.target.style.transform = 'translateY(-2px)';
//                   }}
//                   onMouseLeave={(e) => {
//                     e.target.style.backgroundColor = '#555';
//                     e.target.style.transform = 'translateY(0)';
//                   }}
//                 >
//                   Edit
//                 </button>
//                 <button 
//                   style={styles.btnDelete}
//                   onClick={() => handleDelete(award.id)}
//                   onMouseEnter={(e) => {
//                     e.target.style.backgroundColor = '#d32f2f';
//                     e.target.style.color = 'white';
//                     e.target.style.transform = 'translateY(-2px)';
//                   }}
//                   onMouseLeave={(e) => {
//                     e.target.style.backgroundColor = 'white';
//                     e.target.style.color = '#d32f2f';
//                     e.target.style.transform = 'translateY(0)';
//                   }}
//                 >
//                   Delete
//                 </button>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       {displayawards.length === 0 && (
//         <div style={styles.emptyState}>
//           <p style={styles.emptyText}>No awards added yet. Click "Add New Award" to get started.</p>
//         </div>
//       )}
//     </div>
//   );
// };

export default Awards;